import FaqIcon from '../assets/icons/FaqIcon'
import clsx from 'clsx';

const noop = () => {};

//Dropdown component
type DropDownProps = {
  optionsList: string[]
  label: string
  tooltip: string
  val: string | number
  onChange: (value: string | number) => void,
  edit : boolean

}

export const DropDownWithLabel = ({
  optionsList = [],
  label = "",
  tooltip = "",
  val,
  onChange,
  edit = true
}: DropDownProps) => {
  return (
      <div className="w-full h-full flex flex-col">
        <div className="flex items-center">
          <p className="px-2 text-sm text-[#475569]">{label}</p>
          <button title={tooltip}>
            <FaqIcon darkMode={false} width="16" height="16" />
          </button>
        </div>
        <DropDown
          optionsList={optionsList}
          label={label}
          tooltip={tooltip}
          val={val}
          onChange={onChange}
          edit = {edit}
        />
      </div>
  )
}

export const DropDown = ({
  optionsList=[],
  label="",
  tooltip="",
  val="",
  onChange,
  edit = true
}: DropDownProps) => {
    
    const normalizeValue = (value: any) =>
    typeof value === 'object' ? JSON.stringify(value) : value;

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const raw = e.target.value;

    try {
        // Try parsing JSON — fallback to raw string if it fails
        const parsed = JSON.parse(raw);
        onChange(parsed);
    } catch {
        onChange(raw);
    }
    };

    return (
    <div className="h-full w-full flex items-center focus:outline-2 border z-20 rounded-lg border border-inset border-[#94a3b8]">
        <select
        id={label}
        name={label}
        aria-label={label}
        className={clsx("h-full w-full p-2 rounded-lg  text-base text-[#1e293b] placeholder:text-gray-500", )}
        value={normalizeValue(val)}
        onChange={handleChange}
        disabled={!edit}
        >
        {Object.entries(optionsList).map(([key, value]) => (
            <option key={key} value={normalizeValue(value)} className='text-sm '>
                {key}
            </option>
        ))}
        </select>
    </div>
    )
}

//Input Component
type InputProps = {
  label: string
  placeHolder: string
  type: string | 'text'
  tooltip: string
  val: string | number
  onChange: (value: string | number) => void | void,
  edit : boolean
}

export const InputWithLabel = ({
  label = "",
  placeHolder = "",
  type = "text",
  tooltip = "",
  val = "",
  edit = true,
  onChange = noop,
}: InputProps) => {
  return (
    <div className="h-full w-full flex flex-col ">
      <div className="flex items-center">
        <p className="px-2 text-sm text-[#475569] z-10">{label}</p>
        <button title={tooltip}>
          <FaqIcon darkMode={false} width="16" height="16" />
        </button>
      </div>
      <Input
        label={label}
        placeHolder={placeHolder}
        tooltip={tooltip}
        type={type}
        val={val}
        onChange={onChange}
        edit = {edit}
      />
    </div>
  )
}

export const Input = ({
  label = "",
  placeHolder = "",
  type = "text",
  tooltip = "",
  val = "",
  onChange = noop ,
  edit = true
}: InputProps) => {
  return (
    <input
      type={type}
      className={clsx("h-full w-full border rounded-lg px-2 py-3 text-base text-[#1e293b] border border-inset border-[#94a3b8]",
                      val == "" && "ring-1 ring-inset ring-[#ff4a4a]/50 bg-[#FFE5E5]")}
      placeholder={placeHolder}
      value={val}
      onChange={(e) => onChange(e.target.value)}
      disabled = {!edit}
    />
  )
}

export const Spinner = ({ className }: { className?: string }) => (
  <svg
    aria-hidden="true"
    viewBox="0 0 100 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={clsx(
      "inline w-4 h-4 animate-spin",
      "text-gray-200 dark:text-gray-600",
      "fill-gray-600 dark:fill-gray-300",
      className
    )}
  >
    <path
      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
      fill="currentColor"
    />
    <path
      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
      fill="currentFill"
    />
  </svg>
);
